<script setup lang="ts">
import { FontAwesomeIcon } from '@shared/plugin/icons';
import VTooltip from '@shared/component/VTooltip/VTooltip.vue';
import { type RouteLocationRaw } from 'vue-router';
import { type FontAwesomeIconProps } from '@fortawesome/vue-fontawesome';

defineProps<{
  identifier?: string;
  title: string;
  subText?: string;
  icon: FontAwesomeIconProps['icon'];
  dangerLabel?: string;
  mutatie?: { reden?: string; redenUitgebreid?: string };
  link?: RouteLocationRaw;
}>();
</script>
<template>
  <div class="flex justify-between lg:items-center">
    <VTooltip :active="!!dangerLabel" :label="dangerLabel">
      <div
        :class="{ 'bg-red-100 text-red': dangerLabel }"
        class="flex size-8 items-center justify-center rounded-full bg-grey-accent-100 text-grey-accent-200"
      >
        <FontAwesomeIcon :icon />
      </div>
    </VTooltip>
    <component
      :is="link ? 'RouterLink' : 'div'"
      class="mx-4 flex-grow text-sm text-inherit no-underline lg:flex lg:items-center"
      :to="link"
    >
      <div class="w-24">{{ identifier }}</div>
      <div class="mt-1 lg:ml-4 lg:mt-0 xl:ml-10">{{ title }}</div>
      <div class="mt-1 text-grey-500 lg:ml-2 lg:mt-0">{{ subText }}</div>
    </component>

    <div v-if="!!mutatie">
      <div class="ml-2 mr-4 flex items-center gap-2 justify-self-start">
        <VTooltip :active="!!mutatie.redenUitgebreid" :label="mutatie.redenUitgebreid">
          <span
            :data-testid="`subpolis-${identifier}-reden`"
            class="max-w-16 truncate font-bold text-green max-lg:text-wrap sm:max-w-24 md:max-w-60"
          >
            {{ mutatie.reden }}
          </span>
        </VTooltip>
        <slot name="mutatieActie"></slot>
      </div>
    </div>

    <div class="w-6">
      <slot name="end"></slot>
    </div>
  </div>
</template>
